import { trigger, transition, style, animate } from '@angular/animations';
import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { faStar as faLightStar } from '@fortawesome/pro-light-svg-icons';
import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { SurveyFeedback } from '@empathy/survey/base';

@Component({
  selector: 'empathy-feedback-view',
  templateUrl: 'feedback-view.component.html',
  styleUrls: ['./feedback-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [trigger('showFooter', [transition(':enter', [style({ opacity: 0 }), animate('250ms cubic-bezier(.17,.67,1,1.04)')])])]
})
export class FeedbackViewComponent {
  submit = output<SurveyFeedback>();

  faStar = faStar;
  faLightStar = faLightStar;

  feedbackForm = new FormGroup({
    rating: new FormControl(0),
    feedback: new FormControl('')
  });

  readonly maxMessageLength = 1500;

  onRate(rating: number): void {
    this.feedbackForm.get('rating').setValue(rating);
  }

  onSubmitFeedback(): void {
    this.submit.emit(this.feedbackForm.getRawValue());
  }
}
